/**
 * Strategic Home Page - Buried Point Configuration
 * 埋点配置 - 首页
 * 
 * Note: Each tab is treated as a separate page view since they show different content
 */

const typeId = 'mgmt_pc_v2';
const source = 0;

// Business Management Tab (as a page view)
export const BusinessTab = {
  pageName: 'Strategic Home - Business Management',
  pageId: '100001',
  pagePath: '/strategic/home?tab=business',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100001001',
      buttonName: 'Business Overview',
    },
  },
};

// Studio Management Tab (as a page view)
export const StudioTab = {
  pageName: 'Strategic Home - Studio Management',
  pageId: '100002',
  pagePath: '/strategic/home?tab=studio',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100002001',
      buttonName: 'Studio Management',
    },
  },
};

// Publishing Management Tab (as a page view)
export const PublishingTab = {
  pageName: 'Strategic Home - Publishing Management',
  pageId: '100003',
  pagePath: '/strategic/home?tab=publishing',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100003001',
      buttonName: 'Publishing Management',
    },
  },
};

// Export all configs
export default {
  business: BusinessTab,
  studio: StudioTab,
  publishing: PublishingTab,
};

